import TicketBar from "./ticket-bar/TicketBar";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Card } from "@mui/material";
import SingleTicket from "./SingleTicket";
import AddTicket from "./AddTicket";
import { useParams } from "react-router-dom";

const Ticket = () => {
  const { ticketId } = useParams();

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12} lg={3}>
        <TicketBar />
      </Grid2>
      <Grid2 xs={12} lg={9}>
        <Card
          sx={{
            minHeight: "88vh",
            position: "relative",
          }}
        >
          {ticketId ? <SingleTicket /> : <AddTicket />}
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default Ticket;
